import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { USER_PERMISSIONS } from '@siat-fe/core';
import {
  GetPermessiList,
  GetSelectedStruttura,
  GetStruttureList,
  UserProvider,
} from '../services';

/**
 * redirects a bare /home visit to the right landing route, and any deeper /home/** visit to the
 * struttura picker if no real struttura is currently selected.
 * @returns {boolean | UrlTree} the target url tree, or true to let the route through unchanged.
 */
export const homeInitialRedirectGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userProvider = inject(UserProvider);

  const struttureList = GetStruttureList() || [];
  const selectedStruttura = GetSelectedStruttura();
  const hasRealHomeStruttura =
    !!selectedStruttura &&
    struttureList.some((s) => s.id === selectedStruttura.id);

  if (!hasRealHomeStruttura) {
    userProvider.clearSelectedStruttura();
  }

  if (state.url !== '/home') {
    if (!hasRealHomeStruttura) {
      return struttureList.length > 0
        ? router.createUrlTree(['/apps'])
        : router.createUrlTree(['/404-page']);
    }
    return true;
  }

  const permessiList = GetPermessiList();
  const hasOperativo = permessiList?.includes(USER_PERMISSIONS.operativo);
  const hasCoordinatore = permessiList?.includes(USER_PERMISSIONS.coordinatore);

  if (hasCoordinatore) return router.createUrlTree(['home/dashboard']);
  if (hasOperativo) return router.createUrlTree(['home/calendario']);

  if (hasRealHomeStruttura && (permessiList?.length ?? 0) > 0) {
    return router.createUrlTree(['home/dashboard']);
  }

  if (struttureList.length > 0) {
    return router.createUrlTree(['/apps']);
  }

  return router.createUrlTree(['/404-page']);
};
